import type React from "react";
import { useEffect, useRef, useState } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import {
    StyledCollapsible,
    StyledSettingsSection,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/PreviousSettings/styles";

export const PreviousSettings: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleToggle = () => setIsCollapsed(!isCollapsed);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;
        if (!isCollapsed) {
            timeoutId = setTimeout(() => {
                containerRef.current?.scrollIntoView({ behavior: "smooth" });
            }, 300);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [isCollapsed]);

    return (
        <>
            <StyledSettingsSection
                isCollapsed={isCollapsed}
                onClick={handleToggle}
                ref={containerRef}
                data-automation="previous-settings"
            >
                <SWReactIcons
                    iconName={isCollapsed ? "chev-right" : "chev-up"}
                    iconColor={colorsPalettes.carbon[300]}
                    size="24px"
                />
                {translate("si.agent_knowledge_base.modal.prevSettings.title")}
            </StyledSettingsSection>
            <StyledCollapsible isActive={!isCollapsed}>{children}</StyledCollapsible>
        </>
    );
};
